import { Route, Routes, UrlSegment } from '@angular/router';

import { AuraAuthGuard } from '@digital-platform/aura-authentication/guards';
import { AbandonCartGuard } from '@digital-platform/rs-cart/services';

/**
 * Match where a url segment STARTS with a path(so children aren't abandoned)
 * @param path
 * @returns
 */
const pathToMatch = (path: string) => (url: UrlSegment[]) =>
  url.length > 0 && url[0]?.path === path ? { consumed: url } : null;

/**
 * Common route config for guarding v1 routes before the fallback gets them
 */
const routeProps: Partial<Route> = {
  canDeactivate: [AbandonCartGuard],
  canActivate: [AuraAuthGuard],
  runGuardsAndResolvers: 'always',
  loadChildren: () =>
    import('@digital-platform/rs-frontend/feature-fallback-page').then(
      (m) => m.ROUTES
    ),
};

/**
 * These cover all routes protected in v1 by the AuthGuardService.
 * By guarding here on v2, we ensure we're authenticated and tokens are set
 * in localstorage in time for v1 to use them to get user cdh acct. data
 */
export const v1ProtectedRoutes: Routes = [
  {
    matcher: pathToMatch('account'),
    ...routeProps,
  },
  {
    matcher: pathToMatch('admin'),
    ...routeProps,
  },
  {
    path: 'verify-profile-info',
    ...routeProps,
  },
];
